"use client";
import { useTranslation } from "react-i18next";

const Header = ({ title }: { title: string }) => {
  const { t } = useTranslation();

  return (
    <header className="bg-gradient-to-br from-[#667eea] to-[#764ba2] text-white py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          {title}
          {t("video_download_tool")}
        </h1>
        <p className="text-xl opacity-90">{t("video_download_description")}</p>
      </div>
    </header>
  );
};

export default Header;
